/**
 * BİR İŞİN ÖBÜR YOLU: "İçe aktar" (kullanıcı kararı 02.11.2026; CLAUDE.md §6,
 * `claude/notlar/2026-11-02-bir-isin-obur-yolu-kararlar.md`).
 *
 * Hareket ve hesap elle de, dosyadan da girilir; elle giriş ekranında öbür
 * yol görünür ve İçe aktar sayfasına götürür. İçe aktarma ücretli: ücretsiz
 * kasada düğme kilit simgesiyle görünür, basınca sayfaya gitmez, kilit
 * ifadesi (Abonelik bağlantısı) açılır. Kilit anormallik değildir — uyarı
 * işareti ve yargı rengi yok.
 */

import { useState } from "react";
import { routeHref } from "../lib/router";
import { M } from "../dil";
import { useSinirlar } from "./KabiliyetSaglayici";
import { KilitliKabiliyet, KilitSimgesi } from "./KilitliKabiliyet";

export function IceAktarYolu() {
  const sinir = useSinirlar();
  const [kilitAcik, setKilitAcik] = useState(false);
  const etiket = M.kabuk.sayfa["ice-aktar"];
  if (sinir.iceAktarma || sinir.kurumEkstresi) {
    return (
      <a className="pf-btn pf-btn-ghost" href={routeHref("ice-aktar")}>
        {etiket}
      </a>
    );
  }
  return (
    <span className="flex flex-wrap items-center gap-2">
      <button type="button" className="pf-btn pf-btn-ghost" aria-expanded={kilitAcik} onClick={() => setKilitAcik((a) => !a)}>
        <KilitSimgesi /> {etiket}
      </button>
      {kilitAcik && <KilitliKabiliyet ne={M.iceAktar.ekran.kilitDosya} />}
    </span>
  );
}

/** Elle fiyat ↔ Elle değerleme: izlenmeyen bir varlığı değerlemenin iki yolu. */
export function ElleDegerlemeYolu({ hedef }: { readonly hedef: "fiyatlar" | "degerleme" }) {
  return (
    <a className="pf-btn pf-btn-ghost" href={routeHref(hedef)}>
      {M.kabuk.sayfa[hedef]}
    </a>
  );
}
